import { dateKey } from '../../lib/dateKey';
import type { SyncedTree } from '../../lib/types';

// Serialize the synced tree as JSON and trigger a download in the browser.
// IO-heavy; not unit-tested. The matching parser lives in importBackup.ts.
export function downloadBackup(tree: SyncedTree, filename?: string): void {
  const blob = new Blob([JSON.stringify(tree, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename ?? `aamusankari-backup-${dateKey()}.json`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
